import type { FaireProductEntity } from "../../entity_types/product";

export const p_3aq8cn53et: FaireProductEntity = {
  token: "p_3aq8cn53et",
  type: "product",
  name: "Antique Gold Cz Adjustable Bracelet Watch",
  brandToken: "b_4ahkhhvtpz",
  brandName: "Collections by Fame Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/149fe99631ad42224429c314d18c5cb3f1f89a228aaa72689f1a988de6eb7b63.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32dc7d67bf1e611b0df8a5f2853530a48a95be05d5aa1e083a8f84500ee82273.jpeg",
    "https://cdn.faire.com/fastly/85efd35587f747bd9c85cd4d78e22240f1467b2f187a27dcb131eb080b1d7dda.jpeg",
    "https://cdn.faire.com/fastly/1e830f55474de825939454916b860d74d63251b8e577ae91f3df203fd2f98526.jpeg",
    "https://cdn.faire.com/fastly/9bd50a08196113768da46e7551c5a97423a62232fb1ccd584a1cd78cf2357200.jpeg",
  ],
  priceDollars: 7.97,
  description:
    "This bracelet introduces a stunning antique gold cubic zirconia adjustable watch style. Revel in the intricate design that effortlessly distinguishes this bracelet, making it a statement piece.\r\n\r\nSTAINLESS STEEL\r\n\r\nMADE IN CHINA\r\n\r\n40% S STEEL\r\n30% ZINC\r\n20% GLASS\r\n10% BRASS",
  tags: [],
  msrpDollars: 29.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:40.123Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
